<template>
   <div class="media-drive-wrapper max-w-[800px] mx-auto px-3.5 sm:px-0">

        <div class="media-drive-menu w-full flex items-center justify-center gap-0 sm:divide-x-0 divide-x divide-gray-200 sm:gap-2 mb-6" v-if="!section">

            <button type="button" class="px-3.5 sm:px-7 flex items-center h-10 sm:h-11 rounded-l-md sm:rounded-md text-xs sm:text-sm antialiased font-medium sm:tracking-wide transition-all duration-300 gap-1 group/navlink" :class="{ 'active bg-cyan-800 text-white hover:bg-cyan-700': activeSection == 'photos', 'inactive bg-gray-50 shadow-[1px_1px_0_1px_rgba(0,0,0,.05)] ring-1 ring-[rgba(0,0,0,.05)] text-cyan-950 text-opacity-80': activeSection !== 'photos' }" @click="activeSection = 'photos'" v-if="photos.length">
                <RectangleStackIcon class="w-4 h-4 sm:w-5 sm:h-5 -mt-px transition-colors duration-300 group-hover/navlink:text-[#EC7B7B]" />
                <span>PHOTOS</span>
            </button>
            <button type="button" class="px-3.5 sm:px-7 flex items-center h-10 sm:h-11 sm:rounded-md text-xs sm:text-sm antialiased font-medium sm:tracking-wide transition-all duration-300 gap-1 group/navlink" :class="{ 'active bg-cyan-800 text-white hover:bg-cyan-700': activeSection == 'videos', 'inactive bg-gray-50 shadow-[1px_1px_0_1px_rgba(0,0,0,.05)] ring-1 ring-[rgba(0,0,0,.05)] text-cyan-950 text-opacity-80': activeSection !== 'videos' }" @click="activeSection = 'videos'" v-if="videos.length">
                <PlayIcon class="w-4 h-4 sm:w-5 sm:h-5 -mt-px transition-colors duration-300 group-hover/navlink:text-[#EC7B7B]" />
                <span>VIDEOS</span>
            </button>
            <button type="button" class="px-3.5 sm:px-7 flex items-center h-10 sm:h-11 rounded-r-md sm:rounded-md text-xs sm:text-sm antialiased font-medium sm:tracking-wide transition-all duration-300 gap-1 group/navlink" :class="{ 'active bg-cyan-800 text-white hover:bg-cyan-700': activeSection == 'brochures', 'inactive bg-gray-50 shadow-[1px_1px_0_1px_rgba(0,0,0,.05)] ring-1 ring-[rgba(0,0,0,.05)] text-cyan-950 text-opacity-80': activeSection !== 'brochures' }" @click="activeSection = 'brochures'" v-if="brochures.length">
                <NewspaperIcon class="w-4 h-4 sm:w-5 sm:h-5 -mt-px transition-colors duration-300 group-hover/navlink:text-[#EC7B7B]" />
                <span>DOWNLOADS</span>
            </button>

        </div>

        <div class="media-drive-menu w-full flex items-center justify-center gap-0 sm:divide-x-0 divide-x divide-gray-200 sm:gap-2 mb-6" v-if="section">
            <a class="px-3.5 sm:px-7 flex items-center h-10 sm:h-11 rounded-l-md sm:rounded-md text-xs sm:text-sm antialiased font-medium sm:tracking-wide transition-all duration-300 gap-1 group/navlink" href="/media-drive/photos" :class="{ 'active bg-cyan-800 text-white hover:bg-cyan-800': activeSection == 'photos', 'inactive bg-gray-50 shadow-[1px_1px_0_1px_rgba(0,0,0,.05)] ring-1 ring-[rgba(0,0,0,.05)] text-cyan-950 text-opacity-80': activeSection !== 'photos' }">
                <RectangleStackIcon class="w-4 h-4 sm:w-5 sm:h-5 -mt-px transition-colors duration-300 group-hover/navlink:text-[#EC7B7B]" />
                <span>PHOTOS</span>
            </a>
            <a class="px-3.5 sm:px-7 flex items-center h-10 sm:h-11 sm:rounded-md text-xs sm:text-sm antialiased font-medium sm:tracking-wide transition-all duration-300 gap-1 group/navlink" href="/media-drive/videos" :class="{ 'active bg-cyan-800 text-white hover:bg-cyan-700': activeSection == 'videos', 'inactive bg-gray-50 shadow-[1px_1px_0_1px_rgba(0,0,0,.05)] ring-1 ring-[rgba(0,0,0,.05)] text-cyan-950 text-opacity-80': activeSection !== 'videos' }">
                <PlayIcon class="w-4 h-4 sm:w-5 sm:h-5 -mt-px transition-colors duration-300 group-hover/navlink:text-[#EC7B7B]" />
                <span>VIDEOS</span>
            </a>
            <a class="px-3.5 sm:px-7 flex items-center h-10 sm:h-11 rounded-r-md sm:rounded-md text-xs sm:text-sm antialiased font-medium sm:tracking-wide transition-all duration-300 gap-1 group/navlink" href="/media-drive/brochures" :class="{ 'active bg-cyan-800 text-white hover:bg-cyan-700': activeSection == 'brochures', 'inactive bg-gray-50 shadow-[1px_1px_0_1px_rgba(0,0,0,.05)] ring-1 ring-[rgba(0,0,0,.05)] text-cyan-950 text-opacity-80': activeSection !== 'brochures' }">
                <NewspaperIcon class="w-4 h-4 sm:w-5 sm:h-5 -mt-px transition-colors duration-300 group-hover/navlink:text-[#EC7B7B]" />
                <span>DOWNLOADS</span>
            </a>

        </div>


        <div class="filters rounded-md bg-gray-50 p-6 mb-9 ring-1 ring-gray-200 ring-opacity-70 shadow-[2px_2px_0_rgba(0,0,0,.03)] text-gray-500">
            <h3 class="text-sm font-medium antialiased mb-4 flex items-center gap-1.5 leading-tight">

                <svg class="w-5 h-5 text-[#D24747] -mt-px" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9L20.4 25.8178V38.4444L27.6 42V25.8178L42 9H6Z" fill="currentColor" stroke="currentColor" stroke-width="4" stroke-linejoin="round"/></svg>
                <span class="leading-4 text-[.84rem]">FILTER MEDIA</span>
            </h3>
            <div class="filter-items w-full grid sm:flex sm:items-center gap-5">
                <div class="filter-item sm:w-[260px]">

                    <input type="text" class="bg-white ring-1 ring-gray-200 h-10 px-3 text-[.8rem] text-gray-500 rounded-[4px] focus:ring-2 focus:ring-cyan-900 transition-all duration-300 focus:outline-none w-full caret-cyan-900" placeholder="Enter a keyword" v-model="filters.keyword" />
                </div>
                <div class="filter-item relative sm:w-[260px]">
                    <select v-model="filters.category" class="bg-white ring-1 ring-gray-200 h-10 px-3 text-[.8rem] rounded-[4px] focus:ring-2 focus:ring-cyan-900 transition-all duration-300 focus:outline-none w-full appearance-none" :class="{
                        'text-gray-400': filters.category == null,
                        'text-gray-500': filters.category != null
                    }">

                        <option :value="null">- Select a Category -</option>
                        <option v-for="category in categories" :value="category.value" :key="category.value">{{ category.name }}</option>
                    </select>
                    <span class="select-caret text-gray-400 flex items-center justify-center absolute right-0 top-0 h-full w-9">
                        <svg class="w-5 h-5" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M36 18L24 30L12 18" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    </span>
                </div>


                <div class="ml-auto" v-if="filtersDirty">
                    <button class="text-[.8rem] uppercase antialiased font-medium text-gray-400 hover:text-gray-500 flex items-center leading-[1em] px-3 transition-colors duration-300" type="button" @click="clearFilters">
                        <svg class="w-6 h-6 mt-[-2px]" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 14L34 34" stroke="#c20000" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 34L34 14" stroke="#c20000" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg>

                        <span>Clear Filters</span>
                    </button>
                </div>

            </div>
        </div>

        <div class="grid-sections" ref="gridSections">
            <div ref="photoGrid" class="media-grid grid sm:grid-cols-2 md:grid-cols-3 gap-4" v-if="activeSection == 'photos'">

                <div class="col-span-3 py-10 flex flex-col items-center" v-if="photos.length == 0">
                    <h3 class="mb-2 text-[.9rem] font-medium text-gray-500 antialiased">No photos found.</h3>
                    <p class="text-xs text-gray-400 mb-3.5">Please check your filters and try again.</p>
                    <button class="text-xs uppercase antialiased font-medium text-gray-400 hover:text-gray-500 flex items-center leading-[1em] pl-2 pr-4 transition-colors duration-300" type="button" @click="clearFilters">
                        <svg class="w-5 h-5 mt-[-2px]" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 14L34 34" stroke="#c20000" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 34L34 14" stroke="#c20000" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg>

                        <span>Clear Filters</span>
                    </button>
                </div>



                <div class="media-item" v-for="item in photos" :key="item">
                    <GridPhoto v-if="item.type == 'photo_set'" :item="item"></GridPhoto>
                </div>

            </div>

            <div ref="videoGrid" class="media-grid grid sm:grid-cols-2 md:grid-cols-3 gap-4" v-if="activeSection == 'videos'">

                <div class="col-span-3 py-10 flex flex-col items-center" v-if="videos.length == 0">
                    <h3 class="mb-2 text-[.9rem] font-medium text-gray-500 antialiased">No videos found.</h3>
                    <p class="text-xs text-gray-400 mb-3.5">Please check your filters and try again.</p>
                    <button class="text-xs uppercase antialiased font-medium text-gray-400 hover:text-gray-500 flex items-center leading-[1em] pl-2 pr-4 transition-colors duration-300" type="button" @click="clearFilters">
                        <svg class="w-5 h-5 mt-[-2px]" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 14L34 34" stroke="#c20000" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 34L34 14" stroke="#c20000" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg>

                        <span>Clear Filters</span>
                    </button>
                </div>


                <div class="media-item" v-for="item in videos" :key="item">
                    <GridVideo v-if="item.type == 'video'" :item="item"></GridVideo>
                </div>

            </div>

            <div ref="brochureGrid" class="media-grid grid sm:grid-cols-2 md:grid-cols-3 gap-4" v-if="activeSection == 'brochures'">

                <div class="col-span-3 py-10 flex flex-col items-center" v-if="brochures.length == 0">
                    <h3 class="mb-2 text-[.9rem] font-medium text-gray-500 antialiased">No downloads found.</h3>
                    <p class="text-xs text-gray-400 mb-3.5">Please check your filters and try again.</p>
                    <button class="text-xs uppercase antialiased font-medium text-gray-400 hover:text-gray-500 flex items-center leading-[1em] pl-2 pr-4 transition-colors duration-300" type="button" @click="clearFilters">
                        <svg class="w-5 h-5 mt-[-2px]" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 14L34 34" stroke="#c20000" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 34L34 14" stroke="#c20000" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg>

                        <span>Clear Filters</span>
                    </button>
                </div>

                <div class="media-item" v-for="item in brochures" :key="item">
                    <GridBrochure v-if="item.type == 'brochure'" :item="item"></GridBrochure>
                </div>

            </div>

        </div>


        <router-view></router-view>

        <ModalsContainer />

    </div>
</template>
<script setup>
    import { computed, onMounted, ref, watch } from 'vue';
    import { defineStore } from 'pinia'
    import { watchDebounced } from '@vueuse/core'
    import { ModalsContainer } from 'vue-final-modal'

    import { useAutoAnimate } from '@formkit/auto-animate/vue'
    import Fuse from 'fuse.js'

    import { useMediaStore } from '../Stores/Media';

    import { RouterView, useRoute, useRouter } from 'vue-router'

    import GridPhoto from './MediaTypes/GridPhoto.vue';
    import GridVideo from './MediaTypes/GridVideo.vue';
    import GridBrochure from './MediaTypes/GridBrochure.vue';

    import { NewspaperIcon, RectangleStackIcon, PlayIcon } from '@heroicons/vue/24/solid'

    const props = defineProps({
        section: {
            type: String,
            default: null
        },
        mediaArray: {
            type: String,
            default: '[]'
        },
        type: {
            type: String,
            default: 'visitors'
        }
    })

    const router = useRouter()
    const route = useRoute()

    const store = useMediaStore();

    const [videoGrid] = useAutoAnimate()
    const [photoGrid] = useAutoAnimate()
    const [brochureGrid] = useAutoAnimate()
    const [gridSections] = useAutoAnimate()
    //router.push('/users/eduardo')

    const activeSection = ref( props.section )



    const sections = {
        photo_sets: {
            name: 'Photo Sets',
            icon: 'mdi-image-multiple',
            media: []
        },
    }

    const defaultFilters = {
        keyword: '',
        category: null,
        order_by: 'created_at',
    }

    const filters = ref({
        ...defaultFilters
    })

    const clearFilters = () => {
        filters.value = {
            ...defaultFilters
        }
    }





    const filtersDirty = computed(() => {
        return JSON.stringify(filters.value) != JSON.stringify(defaultFilters)
    })

    const media = ref( JSON.parse( props.mediaArray ) )

    console.log('MEDIA', media.value)

    const mediaIndex = new Fuse(media.value, {
        keys: ['post_title', 'description', 'categories', 'tags'],
        threshold: 0.38,
        includeScore: true,
    })

    const filteredMedia = ref( media.value )


    watch(() => ({...filters.value}), (value) => {

        console.log('FILTERS', value)
        console.log('MEDIA', media.value)
        if ( value.keyword ) {
            let results = mediaIndex.search(value.keyword)
            console.log('RESULTS', results)
            filteredMedia.value = results.map(result => result.item)
        } else {
            filteredMedia.value = media.value
        }



    })

    const photos = computed(() => {
        const items = filteredMedia.value;
        let result = items.filter(item => item.type == 'photo_set')
        if (filters.value.category) {
            result = result.filter(item => item.categories.includes(filters.value.category) )
        }
        result = result.filter(item => item.section.includes(props.type))
        return result
    })

    const videos = computed(() => {
        const items = filteredMedia.value;
        let result = items.filter(item => item.type == 'video')
        if (filters.value.category) {
            result = result.filter(item => item.categories.includes(filters.value.category) )
        }
        result = result.filter(item => item.section.includes(props.type))
        return result
    })

    const brochures = computed(() => {
        const items = filteredMedia.value;
        let result = items.filter(item => item.type == 'brochure')
        if (filters.value.category) {
            result = result.filter(item => item.categories.includes(filters.value.category) )
        }
        result = result.filter(item => item.section.includes(props.type))
        return result
    })


    if (!props.section) {
        if (photos.value.length) {
            activeSection.value = 'photos'
        } else if (videos.value.length) {
            activeSection.value = 'videos'
        } else if (brochures.value.length) {
            activeSection.value = 'brochures'
        }
    }



    const categories = [
        {
            name: 'Art',
            value: 'art'
        },
        {
            name: 'Attractions',
            value: 'attraction'
        },
        {
            name: 'Dining',
            value: 'dining'
        },
        {
            name: 'History',
            value: 'history'
        },
        {
            name: 'Lodging',
            value: 'lodging'
        },
        {
            name: 'Recreation',
            value: 'recreation'
        },
        {
            name: 'Services',
            value: 'service'
        },
        {
            name: 'Shopping',
            value: 'shopping'
        },



    ]

    onMounted(() => {
        const fonts = document.createElement("link");
        fonts.type = "text/css";
        fonts.rel = "stylesheet";
        fonts.href = "https://fonts.googleapis.com/css2?family=Heebo:wght@400;500;600;700&display=swap";
        document.head.appendChild(fonts);

        store.media = media.value

    })

</script>
<style lang="postcss">

@import url('@css/drive.css');

</style>
